import React, { useContext } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { isFuture } from 'date-fns';
import { useRouter } from 'next/router';
import useFlags from '@lib/hooks/useFlags';
import messageStripe from '@components/MessageStripe';
import LanguageContext from '@lib/contexts/languageContext';
import { UserContext } from '@lib/contexts/UserProvider';
import { isEnabledOnPage } from '@lib/utils';

const MessageStripe = styled(messageStripe)`
  position: sticky;
  top: 0;
  padding-left: 0;
  padding-right: 0;
`;

const ENABLED_PATHS = [
  { path: '/[lang]/playlists', exact: false },
  { path: '/[lang]/videos', exact: false },
  { path: '/[lang]', exact: true },
];

const TEXTS = {
  first: {
    se:
      'Investera i din hälsa – ett helt år framöver! Bara 1899 SEK för en årsprenumeration (spara upp till 849 SEK). Klicka här!',
    en:
      'Invest in your health. Upgrade to a yearly subscription for only €189 (and save €80).',
  },
  last: {
    se:
      'SISTA CHANSEN: 1899 SEK för en årsprenumeration (spara upp till 849 SEK). Klicka här!',
    en:
      'LAST CHANCE: only €189 for a yearly subscription (save €80). Click here to claim the offer!',
  },
};

const start_date = new Date(2023, 7, 24, 23);
const end_date = new Date(2023, 9, 10, 23);

const YearlyOffer = () => {
  const router = useRouter();
  const [flags] = useFlags();
  const lang = useContext(LanguageContext);
  const [currentUser] = useContext(UserContext);

  let showYearlyCampaign = false;
  if (
    !currentUser?.id ||
    (currentUser?.isPremium && !currentUser?.subscription.inTrialPeriod)
  ) {
    showYearlyCampaign = true;
  }

  const allowed_on_page = isEnabledOnPage(ENABLED_PATHS, router.pathname);
  if (
    !allowed_on_page ||
    !showYearlyCampaign ||
    !flags?.yearly_campaign ||
    isFuture(start_date) ||
    !isFuture(end_date)
  ) {
    return null;
  }

  const text = isFuture(new Date(2023, 10, 1)) ? TEXTS['first'] : TEXTS['last'];

  return (
    <MessageStripe bg="#D9E8E7" color="#242424">
      <Link href={`/${lang}/yearly`}>
        {text[['se', 'no'].includes(lang) ? 'se' : 'en']}
      </Link>
    </MessageStripe>
  );
};

export default YearlyOffer;
